import { Version } from './version';

export type GroupNameTypes =
  | 'B2B'
  | 'B2C'
  | 'Generic T&C'
  | 'Other Legal Pages';

// Page can be public or admin
// currently we hold the same interface for public and admin
// context, we need to split this into 2 interfaces.
export interface Page {
  id?: number;
  name: string;
  slug: string;
  groupName: GroupNameTypes;
  embeddable: boolean;
  clonable?: boolean;
  publishedVersionId: number;
  lastVersionId: number;
  versions?: Version[];
}

export interface PageDetails {
  name: string;
  liveDate: string;
  content: string;
  nestedCounterList: boolean;
  hideToc: boolean;
}

export const getTitle = (page: PageDetails): string => {
  const titleFromContent = page.content.match(/<h1(?: .*)?>(.*)<\/h1>/m);
  return titleFromContent?.length > 1 ? titleFromContent[1] : page.name;
};

export type GroupedPage = Map<GroupNameTypes, Page>;
